import ProductCardDetails from "./ProductCardDetails";

export default ProductCardDetails;
